if (document.getElementsByClassName("docListWrapper")) {
  const docList = `<div class="mb-5"><div v-if="showFilter != 'False'" class="row bg-light p-4 d-flex align-items-center"> <div class="h3 m-0 mr-3">{{filterText}}</div> <div class="col-lg-4 col-md-6 my-2 p-0"> <div class="dropdown"> <button class="btn-dropdown dropdown-toggle" type="button" id="customDropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" v-html="filterBy =='' ? 'All' : filterBy"></button> <div class="dropdown-menu" aria-labelledby="customDropdownMenuButton"> <button class="dropdown-item" :class="({active : filterBy == ''})" type="button" @click="filterBy = ''">All</button> <button class="dropdown-item" :class="({active : item == filterBy})" type="button" v-for="(item, index) in filterOptions" @click="filterBy = item">{{item}}</button> </div> </div> </div> </div> <div class="list-documents"> <transition-group name="fade" tag="div" class="collapse-group"> <div v-for="(item, idx) in paginatedData" :key="item.Id"> <a :href="item.Url" target="_blank"> <div class="list-icon-left"> <svg class="icon doc" width="38" height="50"> <use xlink:href="#doc"></use> </svg> </div> <div class="list-content mr-3"> <div class="h3" v-html="item.Title"></div> <p class="m-0"> {{item.FileExtension}}, {{item.NumberOfPages}} <span class="d-block d-md-inline-block">Last Updated {{item.LastUpdatedLabel}} , {{item.FileSizeLabel}}</span> </p> </div> </a> </div> </transition-group> </div> <uib-pagination class="ml-auto" v-if="filteredItems !== null && filteredItems.length > itemsPerPage" :total-items="filteredItems.length" :items-per-page="itemsPerPage" v-model="pagination" :max-size="maxSize" :boundary-link-numbers="true" :rotate="false"> </uib-pagination> </div>`;
  Vue.component("docList", {
    template: docList,
    props: ["showFilter", "filterText", "docsData", "filterOptions"],
    data: () => ({
      seen: false,
      filterBy: "",
      pagination: {
        currentPage: 1,
      },
      maxSize: 3,
      itemsPerPage: 5,
    }),
    methods: {
      setPage: function (pageNo) {
        this.pagination.currentPage = pageNo;
      },
    },
    computed: {
      total() {
        return this.docsData.length;
      },
      paginatedData() {
        var firstIndex = (this.pagination.currentPage - 1) * this.itemsPerPage;
        if (firstIndex >= this.filteredItems.length) {
          this.setPage(1);
          firstIndex = (this.pagination.currentPage - 1) * this.itemsPerPage;
        }

        var stopBeforeIndex = this.pagination.currentPage * this.itemsPerPage;
        if (stopBeforeIndex > this.filteredItems.length) {
          stopBeforeIndex = this.filteredItems.length;
        }
        return this.filteredItems.slice(firstIndex, stopBeforeIndex);
      },
      filteredItems() {
        if (this.filterBy !== "") {
          let data = this.docsData.filter((i) =>
              i.Categories.includes(this.filterBy)
            );
          return data;
        } else {
          return this.docsData;
        }
      },
    },
    mounted() {},
    });
    const allElements = document.querySelectorAll(".docListWrapper");
    allElements.forEach(function (item, idx) {
        item.setAttribute("data-id", "docListWrapper_" + idx)
        if (Vue.options.components["uib-pagination"]) {
            new Vue().$mount("[data-id=docListWrapper_"+ idx +"]");
        } else {
        $.getScript(
            "/assets/js/app/vendor/vuejs-uib-pagination.min.js",
            function () {
                new Vue().$mount("[data-id=docListWrapper_" + idx + "]");
            }
        );
        }
    })
}
